// Import model
import { GridFormFieldLayout } from '../models/GridFormFieldLayout';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for GridFormFieldLayout - handles JSON serialization and deserialization with type validation
 */
export class GridFormFieldLayoutSerializer {
  /**
   * Deserializes a JSON string into a GridFormFieldLayout instance
   */
  static deserialize(json: string): GridFormFieldLayout {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a GridFormFieldLayout instance
   */
  static fromObject(obj: any): GridFormFieldLayout {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to GridFormFieldLayout');
    }


    const instance: GridFormFieldLayout = {
      name: obj['Name'] as string,
      width: obj['Width'] as number,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of GridFormFieldLayout instances
   */
  static deserializeArray(json: string): GridFormFieldLayout[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a GridFormFieldLayout instance to a JSON string
   */
  static serialize(instance: GridFormFieldLayout): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a GridFormFieldLayout instance to a plain object
   */
  static toObject(instance: GridFormFieldLayout): any {
    return {
      'Name': instance.name,
      'Width': instance.width,
    };
  }

  /**
   * Serializes an array of GridFormFieldLayout instances to a JSON string
   */
  static serializeArray(instances: GridFormFieldLayout[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
